import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useMutation, useQuery } from "react-query";
import {
  postAddsOneGroup,
  editAddsOneGroup,
  showAddsOneGroup, // لازم يكون عندك API دي
} from "../../../MyApi/addsone";
import { toast } from "react-toastify";
import i18next from "i18next";
import LoadingSpinner from "../../UI/spinner";
   
const AddOnGroupModal = ({
  isOpen,
  toggle,
  store_id,
  refetchGroups,
  mode = "add", // "add" | "edit"
  groupId

}) => {
  const [groupName, setGroupName] = useState("");
const {data ,isLoading} = useQuery(
  ["getAddsOneGroup", store_id, mode === "edit" ? groupId : null],
  () => showAddsOneGroup(groupId),
  { enabled: mode === "edit" }
);
const  groupData = data?.data?.addon_group;
  useEffect(() => {
    if (mode === "edit" && groupData) {
      setGroupName(groupData.name || "");
    } else {
      setGroupName("");
    }
  }, [groupData, mode, isOpen]);


  const mutation = useMutation({
    mutationFn: (postData) =>
      mode === "edit"
        ? editAddsOneGroup(
            { _method: "PUT", lang: i18next.language, ...postData },
            groupData.id
          )
        : postAddsOneGroup(postData),

    onSuccess: (data) => {
      toast.success(data.message);
      setGroupName("");
      toggle();
      refetchGroups();
    },

    onError: (error) => {
      toast.error(error.response?.data?.message );
    },
  });

  /* ---------------- SUBMIT ---------------- */
  const handleSubmit = () => {
    if (!groupName.trim()) {
      toast.error("الرجاء إدخال اسم المجموعة");
      return;
    }

    mutation.mutate({
      name: groupName,
      store_id,
      is_active: 1,
    });
  };

  if(isLoading){
    return <LoadingSpinner/>;
    } 
     return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {mode === "edit" ? "تعديل مجموعة إضافات" : "إضافة مجموعة إضافات"}
      </ModalHeader>

      <ModalBody>
        <label className="form-label">اسم المجموعة</label>
        <input
          className="form-control"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
        />
      </ModalBody>

      <ModalFooter>
        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={mutation.isLoading}
        >
          {mutation.isLoading
            ? "جاري الحفظ..."
            : mode === "edit"
            ? "تحديث"
            : "إضافة"}
        </button>

        <button className="btn btn-white" onClick={toggle}>
          إلغاء
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default AddOnGroupModal;